exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2y4nZiGZ{overflow:auto;grid-column:2;-ms-grid-column:2;grid-row:3}", ""]);

// exports
exports.locals = {
	"container": "_2y4nZiGZ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[hash:base64:8]"}!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist!./src/note/scrollpanel/style.less
// module id = 1224
// module chunks = 1